import React from 'react';  // eslint-disable-line

const Status = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="18" viewBox="0 0 512 512">
            <g stroke="none" strokeWidth="1" fill="#ffffff" fillRule="evenodd">
                <path d="M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z" />
            </g>
        </svg>
    );
};

export default Status;
